var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('router-view',{key:_vm.$route.fullPath}),_c('icons-lib'),_c('snackbar'),(!_vm.inIframe)?_c('navigation-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }